module.exports = __webpack_public_path__ + "img/Schlürf.ef26fd2a.jpg";